// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.script-tab-container {
  display: flex;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.script-rooms {
  width: 220px;
  border-right: 1px solid #333;
  overflow: auto;
}

.script-room-row {
  padding: 4px 6px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
}

.script-room-row:hover {
  background-color: rgba(5, 50, 110, 0.5);
}

.script-room-row.selected {
  color: orange;
}

.script-room-name.active {
  font-weight: bold;
}

.script-models {
  flex: 1;
  overflow: auto;
  padding-left: 8px;
}

.script-model-row {
  cursor: pointer;
  padding: 3px 4px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #333;
}

.script-model-row:hover {
  background-color: rgba(5, 50, 110, 0.5);
}

.script-model-row-deleted {
  color: #6f6f6f;
}

.script-model-row-deleted:hover {
  background-color: rgba(70, 70, 70, 0.2);
}

.script-model-name-deleted {
  color: #8a8a8a;
  text-decoration: line-through;
}

.script-list {
  margin-left: 10px;
  padding: 6px 0 8px;
}

.script-section {
  margin-bottom: 10px;
}

.script-section-label {
  font-size: 0.8em;
  font-weight: bold;
  text-transform: uppercase;
  color: #8fb8ff;
  margin: 0 0 4px 4px;
}

.script-info-table {
  width: calc(100% - 8px);
  margin-left: 4px;
  border-collapse: collapse;
}

.script-info-table th,
.script-info-table td {
  padding: 3px 6px;
  text-align: left;
}

.script-info-table th {
  width: 100px;
  color: #cfcfcf;
  font-weight: 600;
}

.script-row {
  display: flex;
  justify-content: space-between;
  padding: 2px 4px;
  cursor: pointer;
}

.script-row:hover {
  background-color: rgba(5, 50, 110, 0.35);
}

.script-entry {
  margin-bottom: 4px;
}

.script-details {
  margin: 4px 0 8px 12px;
  padding-left: 8px;
  border-left: 1px solid #2f4670;
}

.script-state {
  font-size: 0.85em;
}

.script-state.loading {
  color: #777;
}

.script-state.created {
  color: #aaa;
}

.script-state.initialized {
  color: #e6c400;
}

.script-state.started {
  color: #4da6ff;
}

.script-state.active {
  color: #5fd35f;
}

.script-state.inactive {
  color: #ff9c2a;
}

.script-state.destroyed {
  color: #ff5555;
  text-decoration: line-through;
}

/* MODEL HEALTH COLORS */

.model-green {
  color: #5fd35f;
}

.model-orange {
  color: #ff9c2a;
}

.model-red {
  color: #ff5555;
}

.model-deleted {
  color: #7b7b7b;
}

/* SCRIPT LIFECYCLE COLORS */

.script-state.loading {
  color: #777;
}

.script-state.created {
  color: #aaa;
}

.script-state.initialized {
  color: #e6c400;
}

.script-state.started {
  color: #4da6ff;
}

.script-state.active {
  color: #5fd35f;
}

.script-state.inactive {
  color: #ff9c2a;
}

.script-state.destroyed {
  color: #ff5555;
  text-decoration: line-through;
}

/* manual execution scripts */

.script-manual-badge {
  margin-left: 6px;
  padding: 1px 4px;
  font-size: 0.75em;
  border-radius: 3px;
  background-color: rgba(80, 140, 255, 0.25);
  color: #6fb7ff;
}

.manual-script {
  opacity: 0.85;
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/debug-overlay/script-tab/ScriptTab.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA,wBAAwB;;AAExB;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,4BAA4B;;AAE5B;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA,6BAA6B;;AAE7B;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,aAAa;AACf","sourcesContent":[".script-tab-container {\n  display: flex;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n}\n\n.script-rooms {\n  width: 220px;\n  border-right: 1px solid #333;\n  overflow: auto;\n}\n\n.script-room-row {\n  padding: 4px 6px;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n}\n\n.script-room-row:hover {\n  background-color: rgba(5, 50, 110, 0.5);\n}\n\n.script-room-row.selected {\n  color: orange;\n}\n\n.script-room-name.active {\n  font-weight: bold;\n}\n\n.script-models {\n  flex: 1;\n  overflow: auto;\n  padding-left: 8px;\n}\n\n.script-model-row {\n  cursor: pointer;\n  padding: 3px 4px;\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 1px solid #333;\n}\n\n.script-model-row:hover {\n  background-color: rgba(5, 50, 110, 0.5);\n}\n\n.script-model-row-deleted {\n  color: #6f6f6f;\n}\n\n.script-model-row-deleted:hover {\n  background-color: rgba(70, 70, 70, 0.2);\n}\n\n.script-model-name-deleted {\n  color: #8a8a8a;\n  text-decoration: line-through;\n}\n\n.script-list {\n  margin-left: 10px;\n  padding: 6px 0 8px;\n}\n\n.script-section {\n  margin-bottom: 10px;\n}\n\n.script-section-label {\n  font-size: 0.8em;\n  font-weight: bold;\n  text-transform: uppercase;\n  color: #8fb8ff;\n  margin: 0 0 4px 4px;\n}\n\n.script-info-table {\n  width: calc(100% - 8px);\n  margin-left: 4px;\n  border-collapse: collapse;\n}\n\n.script-info-table th,\n.script-info-table td {\n  padding: 3px 6px;\n  text-align: left;\n}\n\n.script-info-table th {\n  width: 100px;\n  color: #cfcfcf;\n  font-weight: 600;\n}\n\n.script-row {\n  display: flex;\n  justify-content: space-between;\n  padding: 2px 4px;\n  cursor: pointer;\n}\n\n.script-row:hover {\n  background-color: rgba(5, 50, 110, 0.35);\n}\n\n.script-entry {\n  margin-bottom: 4px;\n}\n\n.script-details {\n  margin: 4px 0 8px 12px;\n  padding-left: 8px;\n  border-left: 1px solid #2f4670;\n}\n\n.script-state {\n  font-size: 0.85em;\n}\n\n.script-state.loading {\n  color: #777;\n}\n\n.script-state.created {\n  color: #aaa;\n}\n\n.script-state.initialized {\n  color: #e6c400;\n}\n\n.script-state.started {\n  color: #4da6ff;\n}\n\n.script-state.active {\n  color: #5fd35f;\n}\n\n.script-state.inactive {\n  color: #ff9c2a;\n}\n\n.script-state.destroyed {\n  color: #ff5555;\n  text-decoration: line-through;\n}\n\n/* MODEL HEALTH COLORS */\n\n.model-green {\n  color: #5fd35f;\n}\n\n.model-orange {\n  color: #ff9c2a;\n}\n\n.model-red {\n  color: #ff5555;\n}\n\n.model-deleted {\n  color: #7b7b7b;\n}\n\n/* SCRIPT LIFECYCLE COLORS */\n\n.script-state.loading {\n  color: #777;\n}\n\n.script-state.created {\n  color: #aaa;\n}\n\n.script-state.initialized {\n  color: #e6c400;\n}\n\n.script-state.started {\n  color: #4da6ff;\n}\n\n.script-state.active {\n  color: #5fd35f;\n}\n\n.script-state.inactive {\n  color: #ff9c2a;\n}\n\n.script-state.destroyed {\n  color: #ff5555;\n  text-decoration: line-through;\n}\n\n/* manual execution scripts */\n\n.script-manual-badge {\n  margin-left: 6px;\n  padding: 1px 4px;\n  font-size: 0.75em;\n  border-radius: 3px;\n  background-color: rgba(80, 140, 255, 0.25);\n  color: #6fb7ff;\n}\n\n.manual-script {\n  opacity: 0.85;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
